// API Configuration
const API_CONFIG = {
  // Base URLs for different environments
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api',
  
  // Timeout settings
  TIMEOUT: 30000,
  
  // Endpoints
  ENDPOINTS: {
    CLIENT_ADMIN: '/client-admin',
    PUBLIC: '/public',
    SUPER_ADMIN: '/super-admin'
  }
}

export default API_CONFIG

// Helper function to build full API URLs
export const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`
}

// Helper function for authenticated requests
export const makeAuthenticatedRequest = async (url, options = {}) => {
  const token = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token')

  const defaultHeaders = {
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }

  if (token) {
    defaultHeaders['Authorization'] = `Bearer ${token}`
  }

  let headers = { ...defaultHeaders }
  
  // Only add Content-Type for non-FormData requests
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json'
  }

  const requestOptions = {
    ...options,
    headers: {
      ...headers,
      ...options.headers
    }
  }
  
  try {
    console.log('Making API Request:', {
      url,
      method: requestOptions.method || 'GET',
      headers: requestOptions.headers
    })
    
    const response = await fetch(url, requestOptions)
    
    // Log request details for debugging
    console.log('API Response:', {
      url,
      method: requestOptions.method || 'GET',
      status: response.status,
      statusText: response.statusText,
      headers: Object.fromEntries(response.headers.entries())
    })
    
    // Handle HTML responses (usually 404 or routing errors)
    const contentType = response.headers.get('content-type')
    if (contentType && contentType.includes('text/html')) {
      const htmlText = await response.text()
      console.error('Received HTML response instead of JSON:', htmlText.substring(0, 200))
      throw new Error(`API returned HTML instead of JSON. Status: ${response.status}`)
    }
    
    return response
  } catch (error) {
    console.error('API Request failed:', {
      url,
      method: requestOptions.method || 'GET',
      error: error.message,
      name: error.name,
      stack: error.stack
    })
    
    // Provide better error message based on error type
    if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
      const newError = new Error(`Cannot connect to server. Please check:
      1. XAMPP Apache is running
      2. Server URL is correct: ${API_CONFIG.BASE_URL}
      3. No CORS issues
      
      Original error: ${error.message}`)
      newError.name = 'ConnectionError'
      throw newError
    }
    
    throw error
  }
}